/**
 * Centralized Messages Configuration
 * 
 * This file contains all app messages to prevent duplication across components.
 * Update messages here and they will be reflected throughout the app.
 */

export const MESSAGES = {
    // Opening/Welcome Messages
    LETS_START: "קדימה! בואו נתחיל!",
    GREETING_AND_ASK_NAME: "שלום! איזה כיף שאנחנו הולכים לכתוב מילים ביחד! איך קוראים לך?",
    ASK_WORD: "איזו מילה הייתם רוצים להקליד כעת?",
    
    // Legacy Messages (for backward compatibility)
    ASK_GENDER: "שלום! איזה כיף שאנחנו הולכים לכתוב מילים ביחד! אתה בן או שאת בת?",
    ASK_NAME: "נפלא! ואיך קוראים לך?",
    
    // Dynamic Messages (functions that take parameters)
    GREETING_WITH_NAME: (childName: string) => `היי ${childName}! רוצה שנתאמן קצת בכתיבת מילים?`,
    WORD_INTRODUCTION: (word: string) => `${word} זו מילה מעולה. קדימה. בואו נחפש את כל האותיות שלה במקלדת`,
} as const;

/**
 * Message Types for type safety
 */
export type MessageType = 
    | 'ask_word' 
    | 'greeting_and_ask_name' 
    | 'lets_start' 
    | 'ask_gender' 
    | 'ask_name';

/**
 * Get message text by type
 */
export function getMessageText(messageType: MessageType): string {
    const messageMap = {
        ask_word: MESSAGES.ASK_WORD,
        greeting_and_ask_name: MESSAGES.GREETING_AND_ASK_NAME,
        lets_start: MESSAGES.LETS_START,
        ask_gender: MESSAGES.ASK_GENDER,
        ask_name: MESSAGES.ASK_NAME,
    };
    
    return messageMap[messageType];
}